import React from "react";
import styled from "styled-components";
import ActionHeader from "../../components/ActionHeader";
import { Button } from "baseui/button";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import request from "../../utils/http";
import { useState } from "react";
import { StyledTable, StyledHeadCell, StyledBodyCell } from "baseui/table-grid";
import { ProgressBar } from "baseui/progress-bar";
import enums from "../../utils/enums";
import { Tag } from "baseui/tag";
import { AppContextValue } from "../../AppContext";

const Container = styled.div``;

const StyledTableRow = styled.div`
	display: contents;
	cursor: pointer;
`;

// const perms=AppContextValue.state.auth.permissions;

const CandidateArchive = (props: any) => {
	const urlParams = useParams() as any;
	const navigate = useNavigate();
	const [candidates, setCandidates] = useState([] as any);

	const loadCandidates = async () => {
		let result = await request("GET", `/api/admin/candidate/gc/archive`, null);
		if (result.success && result.data) {
			setCandidates(result.data.candidates);
		}
	};

	useEffect(() => {
		loadCandidates();
	}, [urlParams]);

	return (
		<Container>
			<ActionHeader>
				<h1>Archive</h1>
				<div></div>
			</ActionHeader>
			<hr />
			<StyledTable role="grid" $gridTemplateColumns={"1fr 1fr 1fr 1fr 1fr 1fr"}>
				<StyledTableRow role="row">
					<StyledHeadCell>Name</StyledHeadCell>
					<StyledHeadCell>Allocated to</StyledHeadCell>
					<StyledHeadCell>MOJ Status</StyledHeadCell>
					<StyledHeadCell>Onboarding Progress</StyledHeadCell>			
					<StyledHeadCell>Current Task</StyledHeadCell>
					<StyledHeadCell>Task Progress</StyledHeadCell>
				</StyledTableRow>

				{candidates &&
					candidates.map((candidate: any, i: number) => {
						const striped = i % 2 === 0;
						const mojStatus = enums.candidateMojStatus.find(
							(item: any) => item.value === candidate.currentMOJStatus
						) as any;
						const candidateProgressStatus = enums.candidateProgress.find(
							(item: any) => item.value === candidate.candidateProgress
						) as any;

						return (
							<StyledTableRow
								role="row"
								onClick={() => {
									navigate({
										pathname: `/candidate/${candidate.id}`,
									});
								}}
							>
								<StyledBodyCell $striped={striped}>
									{candidate.name}
								</StyledBodyCell>
								{props.mode !== "my-candidates" && (
									<StyledBodyCell $striped={striped}>
										{candidate.allocatedTo}
									</StyledBodyCell>
								)}
								<StyledBodyCell $striped={striped}>
									<Tag
										closeable={false}
										kind={mojStatus?.kind ?? "primary"}
										variant={mojStatus?.variant ?? "outlined"}
										overrides={{ Text: { style: { maxWidth: "" } } }}
									>
										{mojStatus?.labelShort ?? mojStatus?.label ?? "Unknown"}
									</Tag>
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									{candidateProgressStatus.label}
								</StyledBodyCell>								
								<StyledBodyCell $striped={striped}>
									{candidate.currentTask}
								</StyledBodyCell>
								<StyledBodyCell $striped={striped}>
									<ProgressBar
										value={
											(candidate.currentTaskStep / candidate.currentTaskSteps) *
											100
										}
									/>
								</StyledBodyCell>
							</StyledTableRow>
						);
					})}
			</StyledTable>
		</Container>
	);
};
export default CandidateArchive;
